export const GET_LIST = 'crud/GET_LIST'
export const GET_LIST_LOADING = 'crud/GET_LIST_LOADING'
export const GET_LIST_FAILURE = 'crud/GET_LIST_FAILURE'
export const GET_LIST_SUCCESS = 'crud/GET_LIST_SUCCESS'

export const GET_ONE = 'crud/GET_ONE'
export const GET_ONE_LOADING = 'crud/GET_ONE_LOADING'
export const GET_ONE_FAILURE = 'crud/GET_ONE_FAILURE'
export const GET_ONE_SUCCESS = 'crud/GET_ONE_SUCCESS'

export const CREATE = 'crud/CREATE'
export const CREATE_LOADING = 'crud/CREATE_LOADING'
export const CREATE_FAILURE = 'crud/CREATE_FAILURE'
export const CREATE_SUCCESS = 'crud/CREATE_SUCCESS'

export const UPDATE = 'crud/UPDATE'
export const UPDATE_LOADING = 'crud/UPDATE_LOADING'
export const UPDATE_FAILURE = 'crud/UPDATE_FAILURE'
export const UPDATE_SUCCESS = 'crud/UPDATE_SUCCESS'

export const DELETE = 'crud/DELETE'
export const DELETE_LOADING = 'crud/DELETE_LOADING'
export const DELETE_FAILURE = 'crud/DELETE_FAILURE'
export const DELETE_SUCCESS = 'crud/DELETE_SUCCESS'

export const GET_MANY = 'crud/GET_MANY'
export const GET_MANY_LOADING = 'crud/GET_MANY_LOADING'
export const GET_MANY_FAILURE = 'crud/GET_MANY_FAILURE'
export const GET_MANY_SUCCESS = 'crud/GET_MANY_SUCCESS'

export const GET_SIMPLE = 'crud/GET_SIMPLE'
export const GET_SIMPLE_LOADING = 'crud/GET_SIMPLE_LOADING'
export const GET_SIMPLE_FAILURE = 'crud/GET_SIMPLE_FAILURE'
export const GET_SIMPLE_SUCCESS = 'crud/GET_SIMPLE_SUCCESS'

export const GET_MATCHING = 'crud/GET_MATCHING'
export const GET_MATCHING_LOADING = 'crud/GET_MATCHING_LOADING'
export const GET_MATCHING_FAILURE = 'crud/GET_MATCHING_FAILURE'
export const GET_MATCHING_SUCCESS = 'crud/GET_MATCHING_SUCCESS'

export const GET_MANY_REFERENCE = 'crud/GET_MANY_REFERENCE'
export const GET_MANY_REFERENCE_LOADING = 'crud/GET_MANY_REFERENCE_LOADING'
export const GET_MANY_REFERENCE_FAILURE = 'crud/GET_MANY_REFERENCE_FAILURE'
export const GET_MANY_REFERENCE_SUCCESS = 'crud/GET_MANY_REFERENCE_SUCCESS'

export const CHECK_TEMPLATE = 'ajax/CHECK_TEMPLATE'
export const DOWNLOAD_TEMPLATE = 'ajax/DOWNLOAD_TEMPLATE'



// WEBPACK FOOTER //
// ./state/types/data.js